export const NATIVE_CSS_PROPS = new Set(['display'])

// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_cascade/Shorthand_properties
export const CSS_SHORTHAND_PROPERTIES = new Set<string>([
	'all',
	'animation',
	'background',
	'border',
	'border-block',
	'border-block-end',
	'border-block-start',
	'border-bottom',
	'border-color',
	'border-image',
	'border-inline',
	'border-inline-end',
	'border-inline-start',
	'border-left',
	'border-radius',
	'border-right',
	'border-style',
	'border-top',
	'border-width',
	'column-rule',
	'columns',
	'flex',
	'flex-flow',
	'font',
	'font-variant',
	'gap',
	'grid',
	'grid-area',
	'grid-column',
	'grid-row',
	'grid-template',
	'inset',
	'inset-block',
	'inset-inline',
	'list-style',
	'margin',
	'margin-block',
	'margin-inline',
	'mask',
	'mask-border',
	'offset',
	'outline',
	'overflow',
	'overscroll-behavior',
	'padding',
	'padding-block',
	'padding-inline',
	'place-content',
	'place-items',
	'place-self',
	'scroll-margin',
	'scroll-margin-block',
	'scroll-margin-inline',
	'scroll-padding',
	'scroll-padding-block',
	'scroll-padding-inline',
	'scroll-timeline',
	'text-decoration',
	'text-emphasis',
	'transition',
	'animation-range', // For scroll-driven animations
	'contain-intrinsic-size',
	'container',
	'position-try', // For anchor positioning
	'text-wrap',
	'view-timeline', // For scroll-driven animations
	'-webkit-border-before',
	'-webkit-mask-box-image',
	'-webkit-text-stroke',
])
